// extracted by mini-css-extract-plugin
module.exports = {"container":"FeaturedGuides_container__lD14C","upperButton":"FeaturedGuides_upperButton__4zAaA"};